import bear from './bear.jpg'
import cat from './cat.jpg'
import chicken from './chicken.jpg'
import cow from './cow.jpg'
import dog from './dog.jpg'
import dolphin from './dolphin.jpg'
import hippo from './hippo.jpg'
import horse from './horse.jpg'
import lion from './lion.jpg'
import monkey from './monkey.jpg'
import moose from './moose.jpg'
import mouse from './mouse.jpg'
import pig from './pig.jpg'
import squirrel from './squirrel.jpg'
import turtle from './turtle.jpg'

export interface AvatarPreset {
  id: string
  url: string
}

/**
 * Built-in avatar images bundled with the app rather than stored per-room - the
 * only thumbnail choices available in shared-screen mode, and one of several
 * choices (alongside file upload) otherwise. Not necessarily animals long-term -
 * keep additions here free of animal-specific naming or logic elsewhere.
 */
export const AVATAR_PRESETS: AvatarPreset[] = [
  { id: 'bear', url: bear },
  { id: 'cat', url: cat },
  { id: 'chicken', url: chicken },
  { id: 'cow', url: cow },
  { id: 'dog', url: dog },
  { id: 'dolphin', url: dolphin },
  { id: 'hippo', url: hippo },
  { id: 'horse', url: horse },
  { id: 'lion', url: lion },
  { id: 'monkey', url: monkey },
  { id: 'moose', url: moose },
  { id: 'mouse', url: mouse },
  { id: 'pig', url: pig },
  { id: 'squirrel', url: squirrel },
  { id: 'turtle', url: turtle },
]

const PRESET_PREFIX = 'preset:'

/** Value to store as a mate's thumbnailUrl when they pick a preset (e.g. "preset:bear"). */
export function makePresetThumbnailValue(presetId: string): string {
  return `${PRESET_PREFIX}${presetId}`
}

export function isPresetThumbnailValue(value: string): boolean {
  return value.startsWith(PRESET_PREFIX)
}

/**
 * Resolves a mate's thumbnailUrl value to a real, renderable image URL. Values
 * produced by makePresetThumbnailValue resolve to the matching bundled asset;
 * anything else (data: URL, Clerk https: URL) passes through unchanged.
 */
export function resolveThumbnailUrl(value: string | undefined): string | undefined {
  if (!value || !isPresetThumbnailValue(value)) return value
  const id = value.slice(PRESET_PREFIX.length)
  return AVATAR_PRESETS.find((preset) => preset.id === id)?.url
}
